<div class="input-group">
  <input #dpFromDate
         class="form-control"
         placeholder="{{'lang.globals.selectATimespan' | translate}}"
         value="{{fullDateString}}"
         name="dpFromDate"
         type="text"
         [(ngModel)]="fullDateString"
         (blur)="refreshFromDateString($event)"
         (keydown.enter)="refreshFromDateString($event)"
         [ngStyle]="{'border-color': dateStructFrom > dateStructTill ? '#fd397a' : null}">
  <div class="input-group-append" (click)="toggleDatepicker()">
        <span class="input-group-text h-100">
          <sb-icon icon="calendar"></sb-icon>
        </span>
  </div>
  <div class="input-group datepicker-dropdown">
    <div class="daterangepicker" *ngIf="visible">
      <div class="d-flex flex-row p-2">
        <ngb-datepicker
          #datepicker="ngbDatepicker"
          name="datepicker"
          [showWeekNumbers]="weekNumbers"
          (dateSelect)="onDateSelection($event)"
          [dayTemplate]="t"
          [startDate]="dateStructFrom? dateStructFrom: null"
          [maxDate]="today"
          outsideDays="hidden"
          tabindex="-1"
          [class.d-none]="!visible">
        </ngb-datepicker>
        <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.startDate]="isFirstDayRange(date)"
              [class.endDate]="isLastDayRange(date)"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
        </ng-template>
        <div style="white-space: nowrap; font-size: 0.9rem" class="mx-3 pt-2">
          <div class="d-flex justify-content-between">
            <span>{{'lang.dateRange.from' | translate}}</span>&nbsp;
            <span *ngIf="dateStringFrom" class="font-weight-bold">{{dateStringFrom}}</span>
          </div>
          <ngb-timepicker
            name="timepicker_from"
            [seconds]="showSeconds"
            (ngModelChange)="onTimePickerChanged( 'from', $event)"
            [(ngModel)]="timeStructFrom">
          </ngb-timepicker>

          <div class="d-flex justify-content-between">
            <span>{{'lang.dateRange.to' | translate}}</span>&nbsp;
            <span *ngIf="dateStringTill" class="font-weight-bold">{{dateStringTill}}</span>
          </div>
          <ngb-timepicker
            name="timepicker_till"
            [seconds]="showSeconds"
            (ngModelChange)="onTimePickerChanged('till', $event)"
            [(ngModel)]="timeStructTill">
          </ngb-timepicker>
        </div>
      </div>
      <div class="d-flex datetimepicker-footer justify-content-end p-2" *ngIf="visible">
        <div>
          <button class="btn btn-secondary btn-sm mr-1"
                  (click)="closeDatepicker()">{{'lang.globals.close' | translate}}</button>
          <button *ngIf="showSubmit" [disabled]="!enableApply" class="btn btn-primary btn-sm ml-1"
                  (click)="onDateApply()">{{'lang.globals.apply' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="dateStructFrom > dateStructTill" class="alert alert-danger"
     style="font-size: .7rem">{{'lang.globals.dateWarning'|translate}}</div>
